module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-component', {
    staticClass: "MediaButton",
    attrs: {
      "icon": _vm.icon,
      "label": _vm.label,
      "meta": _vm.meta
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bee68772"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaButton.vue
// module id = 793
// module chunks = 1474